/**
 * Process odds to mach FullBetSlip format
 * @param {Dictionary<string>} displayOdds Initial odds
 * @return {string} Formatted odds
 */
export var getBetSlipOdds = function (displayOdds) {
    return (displayOdds && displayOdds.american)
        ? displayOdds.american.replace("−", "-")
        : "0";
};
//# sourceMappingURL=getBetSlipOdds.js.map